import React from 'react'

const TriangleIcon = () => {
	return (
		<svg viewBox='0 0 42 33' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path d='M21 0L41.7846 32.25H0.215391L21 0Z' fill='currentColor' />
		</svg>
	)
}

export default TriangleIcon
